import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { PRODGY_CHART_COLORS } from '@/shared/constants/colors';
import { useChartTheme } from './chartTheme';

interface DonutChartProps {
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  config: {
    xAxis?: string;
    yAxis?: string;
    xField?: string;
    yField?: string;
    groupBy?: string;
  };
}

export const DonutChart = ({ data, config }: DonutChartProps) => {
  const chart = useChartTheme();

  const rawData = data?.series?.[0]?.data || data?.data || data || [];
  // ECharts pie series espera [{ name, value }]. Quando o data vem de um
  // datasource interno como uma lista de objetos arbitrários (ex:
  // [{ value: 'linkedin', count: 10 }]), mapeamos via xField/yField do
  // transform para gerar o shape esperado.
  const nameField = config?.xField || config?.xAxis;
  const valueField = config?.yField || config?.yAxis;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chartData = Array.isArray(rawData)
    ? rawData.map((d: any) => {
        if (d && typeof d === 'object' && ('name' in d || 'value' in d) && !nameField && !valueField) {
          return d;
        }
        return {
          name: nameField ? d?.[nameField] : d?.name ?? d?.value,
          value: valueField ? d?.[valueField] : d?.value ?? d?.count,
        };
      })
    : [];

  const option: EChartsOption = {
    color: PRODGY_CHART_COLORS,
    backgroundColor: chart.background,
    textStyle: { color: chart.axisLabel },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
      backgroundColor: chart.tooltipBg,
      borderColor: chart.tooltipBorder,
      textStyle: {
        color: chart.tooltipText,
      },
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      type: 'scroll',
      textStyle: {
        color: chart.legendText,
      },
    },
    series: [
      {
        name: data.name || 'Data',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        data: chartData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
        label: {
          show: false,
          position: 'center',
        },
        labelLine: {
          show: false,
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: '100%', width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};
